import { render, staticRenderFns } from "./incrementArrowIcon.vue?vue&type=template&id=4dacf372&"
import script from "./incrementArrowIcon.vue?vue&type=script&lang=js&"
export * from "./incrementArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports